    import React, { useState, useEffect } from 'react'
    import { formatearFecha } from '../utils/FormatearFecha';
    import API from '../utils/api';
    import axios from 'axios';
    import { Button, Card, InputGroup, FloatingLabel, Form } from 'react-bootstrap';
    import { Link } from 'react-router-dom';
    import { PlusLg, TicketDetailed, Search } from 'react-bootstrap-icons';
    import Table from 'react-bootstrap/Table';
    import { useNavigate } from 'react-router-dom';
    import { Container } from 'react-bootstrap';
    import Pagination from '../utils/Pagination'
    import { CardBody, CardHeader, Col, FormGroup, Input, InputGroupText, Label, Row, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
    import { Eye } from 'react-bootstrap-icons';
    import swal from 'sweetalert';
    
import ExportExcel from '../utils/excelexports.js'

const HistorialVentas = () => {

    var url = API.urlAPI
    const UrlVentas = url + "ventas/BuscarVentas"
  

    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [estado, setEstado] = useState('')
  
    const [ventas, setVentas] = useState([]);

    const [verModal, setVerModal] = useState(false)

    const [detalleVenta, setDetalleVenta] = useState({})

    const [search, setSearch] = useState("")
    // COdigo para paginado
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(25);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = ventas.slice(indexOfFirstRecord, indexOfLastRecord);
    const nPages = Math.ceil(ventas.length / recordsPerPage)


    const getVentas = async () => {

        if ([fechaFin, fechaInicio, estado].includes(''))
        {
          swal("", "Todos los campos deben tener valores", "info");
        }
        else
        {
          let res = await fetch(UrlVentas + "/" + estado + "/" + fechaInicio + "/" + fechaFin)
          let data = await res.json()
          setVentas(data)
          console.log(ventas);
          
          console.log(data)
          console.log("Fecha", fechaInicio)
        }
     
    }


    const getColor = (estadoFila) => {
        if (estadoFila == "Finalizado") return '#03C03C';
        return '';
    };



    const searcher = (e) => {
        setSearch(e.target.value)
    }
    const results = !search ? currentRecords : ventas.filter((dato) => dato.IdVenta.toString().includes(search.toLocaleLowerCase()) || dato.Cliente.toLocaleLowerCase().includes(search.toLocaleLowerCase()) || dato.Estado.toLocaleLowerCase().includes(search.toLocaleLowerCase()))


    const ContainerStyle = {
        boxShadow: '1px 2px 9px white',
        background: 'white'
    };


    const mostrarModal = (data) => {
        console.log(data)
        setDetalleVenta(data)
        setVerModal(!verModal);
        console.log("TESTING: ", detalleVenta)
    }
    return (
        <>
            <br></br>
            <Container>
                <br></br>
                <Card style={ContainerStyle} >
                    <Card.Header style={{ background: "#005187", color: "white" }}><h3>Historial Ventas</h3></Card.Header>
                    <Card.Body>
                      
                    <Row className="align-items-end">
              <Col sm={2}>
                <FormGroup>
                  <Label>Fecha Inicio:</Label>
                  <Form.Control type="date"
                    selected={fechaInicio}
                    onChange={(e) => setFechaInicio(e.target.value)}
                    dateFormat='dd-MM-yyyy' />

                </FormGroup>
              </Col>

              <Col sm={2}>
                <FormGroup>
                  <Label>Fecha Fin:</Label>
                  <Form.Control type="date"
                    selected={fechaFin}
                    onChange={(e) => setFechaFin(e.target.value)}
                    dateFormat='dd-MM-yyyy' />


                </FormGroup>
              </Col>

              <Col sm={2}>
                <FormGroup>
                  <Label>Estado:</Label>
                  <Input type="select" name="selectMulti" onChange={(e) => setEstado(e.target.value)} >
                  <option value="">Seleccionar Estado</option>
                    <option value= "Pendiente">Pendiente</option>
                    <option value= "En Curso">En Curso</option>
                    <option value= "Finalizado">Finalizado</option>
                    <option value= "X">Todos</option>
                  </Input>
                  </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>

                  <Label></Label>
                  <Button variant="success" onClick={() => getVentas()}>
                    <Search size={20} /></Button>
                </FormGroup>

              </Col>
            </Row>
                      
                      
                        <br></br>
                        <InputGroup>
                            <InputGroup.Text><Search /></InputGroup.Text>
                            <FloatingLabel
                                controlId="floatingInput"
                                label="Busqueda por Cliente, Estado o N° de Prestamo"
                            >
                                <Form.Control value={search} onChange={searcher} type="text" />
                            </FloatingLabel>
                        </InputGroup>
                        <br></br>

                        <Table responsive >
                            <thead>
                                <tr style={{ background: "#5589c4", color: "white" }}>
                                    <th>Acción</th>
                                    <th>N° Venta</th>
                                    <th>Cliente</th>
                                    <th>Modalidad</th>
                                    <th>Tasa Interes</th>
                                    <th>Adelanto</th>
                                    <th>Importe Venta</th>
                                    <th>Importe Total</th>
                                    <th>Cantidad de Cuotas</th>
                                    <th>Importe Cuota</th>
                                    <th>Total Financiado</th>
                                    <th>Estado</th>
                                    <th>Fecha Alta</th>
                                    <th>Medio Pago</th>
                                    

                                </tr>
                            </thead>
                            <tbody>
                                {results.map((item) =>

                                    <tr key={item.IdVenta}>
                                        <td>

                                            <Button size="sm" variant="outline-primary"
                                                onClick={() => mostrarModal(item)}>
                                               <Eye/> Ver detalle
                                            </Button>

                                        </td>
                                        <td>{item.IdVenta}</td>
                                        <td>{item.Cliente}</td>
                                        <td>{item.ModalidadDescripcion}
                                        </td>
                                        <td>{item.TasaInteres}</td>
                                        
                                        <td>{item.adelanto}</td>
                                        <td>{item.ImporteVenta}</td>
                                        <td>{item.ImporteTotal}</td>
                                        <td>{item.CantCuotas}</td>
                                        <td>{item.ImporteCuota}</td>
                                        <td>{item.CantCuotas * item.ImporteCuota}</td>
                                        <td>{item.Estado}</td>
                                        <td>{formatearFecha(item.FechaAlta)}</td>
                                        <td>{item.medioPago}</td>

                                    </tr>
                                )}
                            </tbody>
                        </Table>


                        <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                        <ExportExcel excelData={ventas} fileName={"Historico Ventas"} />
                        <Modal size="lg" isOpen={verModal}>
                            <ModalHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                                Detalle Venta
                            </ModalHeader>
                            <ModalBody>
                                <Row>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Fecha Alta:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.FechaAlta} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Numero Venta:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.IdVenta} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Modalidad:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.ModalidadDescripcion} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Cliente:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.Cliente} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Cantidad Cuotas:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.CantCuotas} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Estado Venta:</Label>
                                            <Input  style={{ background: getColor(detalleVenta.Estado) }} bsSize="sm" disabled value={detalleVenta.Estado} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Importe Venta:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.ImporteVenta} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Interes:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.TasaInteres} />
                                        </FormGroup>
                                    </Col>
                                    <Col sm={4}>
                                        <FormGroup>
                                            <Label>Importe Total:</Label>
                                            <Input bsSize="sm" disabled value={detalleVenta.ImporteTotal} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Card style={ContainerStyle} >
                                            <Card.Header style={{ background: "#005187", color: "white" }}><h5>Detalle Productos</h5></Card.Header>
                                            <Card.Body>
                                                <Table reponsive striped bordered hover size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Producto</th>
                                                            <th>Cantidad</th>
                                                            <th>PrecioCosto</th>
                                                            <th>PrecioVenta</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            (detalleVenta.ventadetalles == undefined) ? (
                                                                <tr><td colSpan={4}>Sin productos</td></tr>
                                                            ) : (
                                                                detalleVenta.ventadetalles.map((item) => (
                                                                    <tr key={item.Linea}>
                                                                        <td>{item.Producto}</td>
                                                                        <td>{item.Cantidad}</td>
                                                                        <td>{item.PrecioCosto}</td>
                                                                        <td>{item.PrecioVenta}</td>
                                                                    </tr>
                                                                ))
                                                            )
                                                        }

                                                    </tbody>
                                                </Table>
                                            </Card.Body>
                                        </Card>
                                        <Card style={ContainerStyle} >
                                            <Card.Header style={{ background: "#005187", color: "white" }}><h5>Detalle Cuotas</h5></Card.Header>
                                            <Card.Body>
                                                <Table reponsive striped bordered hover size="sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Cuota</th>
                                                            <th>Importe Cuota</th>
                                                            <th>Estado</th>
                                                            <th>Fecha Pago</th>
                                                            <th>Fecha Vencimiento</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            (detalleVenta.ventacuotas == undefined) ? (
                                                                <tr>
                                                                    <td colSpan="5">Pago realizado al contado</td>
                                                                </tr>
                                                            ) : (
                                                                detalleVenta.ventacuotas.map((item) => (
                                                                    <tr key={item.Cuota}>
                                                                        <td>{item.Cuota}</td>

                                                                        <td>{item.CuotaOriginal}</td>
                                                                        <td>{item.Estado}</td>
                                                                        <td>{formatearFecha(item.FechaPago)}</td>
                                                                        <td>{formatearFecha(item.FechaVencimiento)}</td>
                                                                    </tr>
                                                                ))
                                                            )
                                                        }

                                                    </tbody>
                                                </Table>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <Button size="sm" color="danger" onClick={() => setVerModal(!verModal)}>Cerrar</Button>
                            </ModalFooter>
                        </Modal>
                    </Card.Body>
                </Card>
            </Container>


        </>
    )
}

export default HistorialVentas